// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.password-input-wrapper {
  position: relative;
  display: inline-block;
  width: 100%;
}

.password-input {
  width: 100%;
  padding-right: 2.5rem;
}

.password-toggle-btn {
  position: absolute;
  right: 0.5rem;
  top: 50%;
  transform: translateY(-50%);
  background: transparent !important;
  background-color: transparent !important;
  border: none;
  cursor: pointer;
  padding: 0.25rem;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #666 !important;
  transition: color 0.2s ease;
  outline: none;
  box-shadow: none;
  appearance: none;
}

.password-toggle-btn:hover:not(:disabled) {
  color: var(--color-primary, #3b82f6) !important;
  background: transparent !important;
  background-color: transparent !important;
}

.password-toggle-btn:active:not(:disabled) {
  background: transparent !important;
  background-color: transparent !important;
}

.password-toggle-btn:disabled {
  cursor: not-allowed;
  opacity: 0.5;
  background: transparent !important;
  background-color: transparent !important;
}

.password-toggle-btn:focus {
  outline: none;
  background: transparent !important;
  background-color: transparent !important;
}

.password-toggle-btn:focus-visible {
  outline: 2px solid var(--color-primary, #3b82f6);
  outline-offset: 2px;
  border-radius: 0.25rem;
}

.password-toggle-btn svg {
  width: 20px;
  height: 20px;
  stroke: currentColor !important;
  fill: none !important;
  opacity: 1 !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/PasswordInput.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,QAAQ;EACR,2BAA2B;EAC3B,kCAAkC;EAClC,wCAAwC;EACxC,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,2BAA2B;EAC3B,aAAa;EACb,gBAAgB;EAGhB,gBAAgB;AAClB;;AAEA;EACE,+CAA+C;EAC/C,kCAAkC;EAClC,wCAAwC;AAC1C;;AAEA;EACE,kCAAkC;EAClC,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kCAAkC;EAClC,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,wCAAwC;AAC1C;;AAEA;EACE,gDAAgD;EAChD,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,qBAAqB;EACrB,qBAAqB;AACvB","sourcesContent":[".password-input-wrapper {\n  position: relative;\n  display: inline-block;\n  width: 100%;\n}\n\n.password-input {\n  width: 100%;\n  padding-right: 2.5rem;\n}\n\n.password-toggle-btn {\n  position: absolute;\n  right: 0.5rem;\n  top: 50%;\n  transform: translateY(-50%);\n  background: transparent !important;\n  background-color: transparent !important;\n  border: none;\n  cursor: pointer;\n  padding: 0.25rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #666 !important;\n  transition: color 0.2s ease;\n  outline: none;\n  box-shadow: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n}\n\n.password-toggle-btn:hover:not(:disabled) {\n  color: var(--color-primary, #3b82f6) !important;\n  background: transparent !important;\n  background-color: transparent !important;\n}\n\n.password-toggle-btn:active:not(:disabled) {\n  background: transparent !important;\n  background-color: transparent !important;\n}\n\n.password-toggle-btn:disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n  background: transparent !important;\n  background-color: transparent !important;\n}\n\n.password-toggle-btn:focus {\n  outline: none;\n  background: transparent !important;\n  background-color: transparent !important;\n}\n\n.password-toggle-btn:focus-visible {\n  outline: 2px solid var(--color-primary, #3b82f6);\n  outline-offset: 2px;\n  border-radius: 0.25rem;\n}\n\n.password-toggle-btn svg {\n  width: 20px;\n  height: 20px;\n  stroke: currentColor !important;\n  fill: none !important;\n  opacity: 1 !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
